export enum TenantRole {
    Member = 0,
    Admin = 1,
    Owner = 2
}

export interface TenantSettings {
    id: string;
    tenantId: string;
    defaultProfitMargin: number;
    description: string;
    maxMembers: number;
    allowMemberInvites: boolean;
    contributeToGlobalRegistry: boolean;
}

export interface Tenant {
    id: string;
    name: string;
    slug: string;
    isActive: boolean;
    settings?: TenantSettings;
}

export interface TenantMembership {
    id: string;
    tenantId: string;
    userId: string;
    role: TenantRole;
    isActive: boolean;
    username?: string;
    tenant?: Tenant;
    user?: { username: string; id: string };
}
